import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceState = (state: AppState) =>
  state.invitations;

export const selectInvitationsList = createSelector(
  selectDeviceState,
  (state) => state.invitationsList
);

export const selectInvitationsItemsPaginationList = createSelector(
  selectDeviceState,
  (state) => state.itemsPagination
);
export const selectInvitationsHistory = createSelector(
  selectDeviceState,
  (state) => state.invitationsHistory
);
export const selectInvitationsSharing = createSelector(
  selectDeviceState,
  (state) => state.sharing
);
export const selectInvitationsShared = createSelector(
  selectDeviceState,
  (state) => state.shared
);
export const selectInvitationsAccepted = createSelector(
  selectDeviceState,
  (state) => state.accepted
);
export const selectInvitationsAccepting = createSelector(
  selectDeviceState,
  (state) => state.accepting
);
export const selectInvitationsRejected = createSelector(
  selectDeviceState,
  (state) => state.rejected
);
export const selectInvitationsRejecting = createSelector(
  selectDeviceState,
  (state) => state.rejecting
);